import { useCallback, useContext } from "react"
import PageContext from "../components/page-context"
import { getBrand } from "../configuration/brands"

/**
 * Returns a function to get the image for the provided news object.
 * The function will use a fallback image for news articles that don't have a hero image
 * The fallback images live in the static/images/brands/news-fallback-images folder and map to the brand of the page.
 */
export const useGetNewsImage = (brand?: string) => {
  const pageContext = useContext(PageContext)
  const brandName = brand || pageContext?.brand

  return useCallback(
    (news: any) => {
      if (news.content?.tx_headless_news_image?.src) {
        return news.content.tx_headless_news_image
      }

      if (news.content?.image?.src) {
        return news.content.image
      }

      return {
        alternative: "DFB Logo",
        extension: "svg",
        link: [],
        src: getNewsFallbackImageUrl(brandName),
      }
    },
    [brandName],
  )
}

/**
 * Returns the full URL for the fallback image for news articles.
 * @param brand The brand of the page
 */
export const getNewsFallbackImageUrl = (brand: string) => {
  const brandName: string = getBrand(brand).name
  return `${process.env.PUBLIC_CDN_HOST}/images/brands/news-fallback-images/${brandName}.svg`
}
